import Bugsnag from '@bugsnag/js';
import { ReactNode, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginResponse } from '../../api/fusionApi';
import AuthContext from './authContext';

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const store = localStorage.getItem('AdminUser');
  const [state, setState] = useState<LoginResponse | undefined>(
    JSON?.parse(store ?? '{}')
  );
  const location = useLocation();

  if (state?.user?.active) {
    const userData = state.user;
    Bugsnag.setUser(userData?.username, userData?.email, userData?.fullName);
  }

  useEffect(() => {
    if (store) {
      const auth: LoginResponse = JSON.parse(store);
      setState(auth);
    } else {
      setState({});
    }
    // eslint-disable-next-line
  }, [store, location?.pathname]);

  useEffect(() => {
    if (state! && state?.user?.active) {
      const currentPath = window.location.pathname;
      const allowedPaths = [
        '/',
        '/users',
        '/transactions',
        '/transactions/',
        '/settings',
        '/user',
        '/transaction',
      ];

      if (!allowedPaths.includes(currentPath)) {
        navigate('/');
      }
    } else {
      navigate('/login');
    }
    // eslint-disable-next-line
  }, [state, navigate]);

  return (
    <AuthContext.Provider value={{ state, setState }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
